var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maintenance-component"},[_c('div',{staticClass:"container"},[_c('ct-errors-page',{attrs:{"status":_vm.status,"details":_vm.details,"instruction":_vm.instruction,"icon":_vm.icons}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }